/**
 * The interest topics offered wherever a member profile is edited.
 *
 * Lived in CreateAccount.tsx. Moved here when the admin member editor needed the
 * same list: two copies would drift, and an admin offering different topics than
 * the signup form produces interests that no directory filter can match.
 */
export const MEMBER_INTERESTS = [
  "Leadership & Executive Development",
  "Startup Growth & Scaling",
  "Human Resources & People Strategy",
  "AI & The Future of Work",
  "Talent Acquisition & Employer Branding",
  "Organizational Culture & Employee Experience",
  "Diversity, Equity & Inclusion",
  "Learning & Development",
  "Mental Health & Well-being",
  "Legal, Compliance & Risk",
  "Finance, Operations & Business Strategy",
  "Technology & Innovation",
  "Entrepreneurship & Founder Stories",
  "Marketing, Sales & Customer Success",
  "Personal Growth & Career Development",
  "Networking & Community Building",
] as const;
